import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=f25aefc0&"
import script from "./PhoneInput.vue?vue&type=script&lang=ts&"
export * from "./PhoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports